import { IProductDetail } from '@/api/types/public';
import Image from '@/components/Image';
import MagicJump, { JumpTarget } from '@/components/MagicJump';
import { setSession } from '@/utils/tools';
import { RightArrowOutlined } from '@zeelool/icon';

interface ActivityBannerProps {
  item: NonNullable<IProductDetail['commodity_details_label']>[0];
  SDProductDetailsPageBtnClick?: (btnName: string) => void;
}

const ActivityBanner: React.FC<ActivityBannerProps> = ({ item, SDProductDetailsPageBtnClick }) => {
  // 只有 type=activity 且 scene=2 时才渲染
  if (item.type !== 'activity' || item.scene !== 2 || item.status !== 1) {
    return null;
  }

  // 如果没有图片，不渲染
  if (!item.image) {
    return null;
  }

  // 构建跳转目标对象
  const jumpTarget: JumpTarget = {
    jump_type: item.jump_type,
    Jump_target: item.Jump_target,
  };

  const handleJumpClick = () => {
    setSession('zl_goodsListEnterPageScene', '商详页活动标签');
    // 触发埋点
    if (item.button_buried_name) {
      SDProductDetailsPageBtnClick?.(item.button_buried_name);
    } else {
      SDProductDetailsPageBtnClick?.('ActivityBanner');
    }
  };

  return (
    <MagicJump item={jumpTarget} onJumpClick={handleJumpClick} className="cursor-pointer mt-[20px]">
      <div
        className="flex items-center justify-between p-4 rounded-[4px]"
        style={{
          backgroundColor: item.background_color || '#F5F5F5',
        }}
      >
        {/* 左侧图片 */}
        <div className="flex-shrink-0">
          <Image src={item.image} alt="Activity" width={77} height={40} className="rounded" />
        </div>

        {/* 中间活动文案 */}
        <div className="flex-1 mx-4 text-12 text-gray-800 min-w-0">
          {item.activity && (
            <p
              className="truncate"
              style={{
                color: item.text_color,
              }}
            >
              {item.activity}
            </p>
          )}
        </div>

        {/* 右侧跳转按钮 */}
        <div className="flex-shrink-0 flex items-center">
          {item.button && (
            <>
              <button className="px-4 py-2 text-12 font-medium text-[#282828] cursor-pointer">
                {item.button}
              </button>
              <RightArrowOutlined className="text-[#808080] text-[18px]" />
            </>
          )}
        </div>
      </div>
    </MagicJump>
  );
};

export default ActivityBanner;
